import styled from 'styled-components';

import {getColor, getLighteningColor, gts, ms} from '../../../../styles';
import {Text} from '../../../../uikit/Text';
import {View} from '../../../../uikit/View';

export const Container = styled(View)`
  flex-direction: column;
  gap: ${ms(12)};
  padding-block: ${ms(20)} ${ms(12)};
  background-color: ${getColor('background.white')};
`;

export const Title = styled(Text).attrs({
  variant: 'h3',
  weight: 'bold',
})``;

export const DescriptionContainer = styled(View)`
  gap: ${gts('padding.sm')};
  padding: ${gts('padding.sm')} ${gts('padding.me')};
  border-radius: ${gts('borderRadius.sm')};
  background-color: ${getLighteningColor('background.grayDark', 'strong')};
  align-items: center;
`;

export const Description = styled(Text).attrs({
  variant: 'body',
})`
  color: ${getColor('text.gray')};
  flex: 1;
`;
